// extracted by css-extract-rspack-plugin
export default {"cellWrapper":"cellWrapper-HCKx4J","cellText":"cellText-afltDn"};